import { render, staticRenderFns } from "./CircleDetail.vue?vue&type=template&id=967c98f2&scoped=true"
import script from "./CircleDetail.vue?vue&type=script&lang=js"
export * from "./CircleDetail.vue?vue&type=script&lang=js"
import style0 from "./CircleDetail.vue?vue&type=style&index=0&id=967c98f2&prod&scoped=true&lang=css"
import style1 from "./CircleDetail.vue?vue&type=style&index=1&id=967c98f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967c98f2",
  null
  
)

export default component.exports